module.exports = __webpack_public_path__ + "img/obstacle.a882f247.svg";